import { connect } from 'react-redux';
import CartSummaryNoteForm from '../components/Cart/CartSummaryNoteForm';
import { getCurrentCartNotes } from "../selectors/cartSelector";
import { saveNotes, updateNotes } from "../actions/cartActions";

const mapStateToProps = function(store) {
    return {
        isSubmitting: Object.values(store.cart.isRowLoading).some(item => (item && item === true)),
        notes: getCurrentCartNotes(store),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        updateNotes: (value) => dispatch(updateNotes(value)),
        saveNotes: () => dispatch(saveNotes()),
    };
};
const ConnectedCartSummaryNoteForm = connect(mapStateToProps, mapDispatchToProps)(CartSummaryNoteForm);

export default ConnectedCartSummaryNoteForm;
